export default __webpack_public_path__ + "static/media/9t.a8ff8d10.jpg";